import { useState } from "react";
import { Candidate } from "../../models/Candidate";

interface Props {
    candidate: Candidate;
    styles: any;
}

export const ProfileTab: React.FC<Props> = (props) => {
    const styles = props.styles; 
    const candidate = props.candidate;
    const [showFullSummary, setShowFullSummary] = useState<boolean>(false);

    const handleShowFullSummary = () => {
        setShowFullSummary(!showFullSummary);
    };

    const formatNoteText = (text: string) => {
        return text.replace(/\n/g, '<br />');
    };

    return (
        <div style={styles.mainWrapper}>
            <p style={styles.title}>Profile</p>
            {candidate.personalSummary && <div style={styles.personalSummary}>
                <div style={styles.personalSummary.title}>{"Personal Summary"}</div>       
                <div style={styles.personalSummary.text}>
                    {showFullSummary
                        ? <div dangerouslySetInnerHTML={{__html: formatNoteText(candidate.personalSummary)}}/>
                        : <div dangerouslySetInnerHTML={{__html: formatNoteText(`${candidate.personalSummary.substring(0, 240)}...`)}}/>
                    }   
                    {candidate.personalSummary.length > 240 && (
                        <span onClick={() => handleShowFullSummary()} style={styles.seeMore}>
                            {showFullSummary ? "See Less" : "See More"}
                        </span>
                    )}  
                </div>
            </div>}
            <div style={styles.details}>
                {candidate.email && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Email Address"}</div>
                    <div style={styles.details.text}>{candidate.email}</div>
                </div>}
                {candidate.mobileNumber && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Mobile"}</div>
                    <div style={styles.details.text}>{candidate.mobileNumber}</div>
                </div>}
                {candidate.telephone && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Phone"}</div>
                    <div style={styles.details.text}>{candidate.telephone}</div>
                </div>}
                {candidate.address1 && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Address"}</div>
                    <div style={styles.details.text}>{candidate.address1}</div>
                </div>}
                {candidate.createdDate && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Date Created"}</div>
                    <div style={styles.details.text}>{candidate.createdDate && (new Date(candidate.createdDate).toLocaleDateString('en-CA'))}</div>
                </div>}
                {candidate.lastUpdatedDate && <div style={styles.details.box}>
                    <div style={styles.details.title}>{"Last Modified"}</div>
                    <div style={styles.details.text}>{new Date(candidate.lastUpdatedDate).toLocaleDateString('en-CA')}</div>
                </div>}
            </div>
        </div>
    )
}